import { constructRoutes } from "single-spa-layout";
import { isRoutePublic } from "../helpers/publicRoutes";
import { SINGLE_SPA_ROUTE_TYPE, SingleSpaRoute, DRSRoute } from "../types/drs";
import { registerStaticRouting } from "./staticRouting";
const loaderHTML = `
  <div class="core-loading">
    <span></span>
    <span></span>
    <span></span>
  </div>
`;

export const createSingleSpaRoute = (drsRoute: DRSRoute): SingleSpaRoute => {
  const routeConfig = {
    type: SINGLE_SPA_ROUTE_TYPE.ROUTE,
    path: drsRoute.path,
    exact: drsRoute.is_path_exact ?? false,
    routes: [],
  };

  if (drsRoute.is_header_enabled && !isRoutePublic()) {
    const HEADER = { type: "application", name: "@getwell/guac-layout" };
    routeConfig.routes.push(HEADER);
  }

  routeConfig.routes.push({
    type: SINGLE_SPA_ROUTE_TYPE.APPLICATION,
    name: drsRoute.application_identifier,
    loader: loaderHTML,
  });

  return routeConfig;
};

export const createRouting = (drsRoutes: DRSRoute[]) => {
  const singleSpaRoutes = [];

  drsRoutes.forEach((route) => {
    if (route.is_redirect || !route.application_identifier) return;

    const singleSpaRoute = createSingleSpaRoute(route);

    singleSpaRoutes.push(singleSpaRoute);
  });
  registerStaticRouting();
  return constructRoutes({ routes: singleSpaRoutes });
};
